import { useDispatch } from 'react-redux';
import { useFarmId } from '../../../InventoryWidget/useFarmId';
import { useQuery } from '@tanstack/react-query';
import { notificationsConfig } from '../../../../../config/constants';
import { error } from 'react-notification-system-redux';
import { useDeviationsAPI } from './useDeviationsAPI';
import { WidgetType } from '../../../widget.types';
export const deviationQueryKeysMap = {
    [WidgetType.DELIVER_DEVIATION]: ['deliveryDeviations'],
    [WidgetType.LOAD_DEVIATION]: ['loadDeviations'],
};
const nameFieldMap = {
    [WidgetType.DELIVER_DEVIATION]: 'groupName',
    [WidgetType.LOAD_DEVIATION]: 'ingredientName',
};
const idFieldsMap = {
    [WidgetType.DELIVER_DEVIATION]: ['groupId'],
    [WidgetType.LOAD_DEVIATION]: ['ingredientId'],
};
export const useDeviationQuery = (id, widgetType) => {
    const dispatch = useDispatch();
    const api = useDeviationsAPI(widgetType);
    const farmId = useFarmId();
    return useQuery({
        refetchOnMount: true,
        refetchOnReconnect: true,
        refetchOnWindowFocus: true,
        cacheTime: 0,
        onError: () => dispatch(error({
            ...notificationsConfig.defaultConf,
            translationKey: 'widget:widget:cant_load_widgets',
        })),
        enabled: !!farmId || !!id,
        queryFn: () => api.getDeviations(farmId, id),
        queryKey: deviationQueryKeysMap[widgetType],
        select: (data) => ({
            ...data,
            items: data.items.sort((a, b) => (a.dateTime < b.dateTime ? -1 : a.dateTime > b.dateTime ? 1 : 0)),
            name: data[nameFieldMap[widgetType]],
            itemId: data[idFieldsMap[widgetType]],
        }),
    });
};
//# sourceMappingURL=useDeviationQuery.js.map